import { useState, useRef } from 'react';
import { Upload } from 'lucide-react';
import { ope } from '../../../services/api';
import { useToast } from '../../../context/ToastContext';

const OpeAdminPdfUploader = ({ temaId, pdfFilename, textoChars, onUploadSuccess }) => {
    const [uploadingPdf, setUploadingPdf] = useState(false);
    const fileInputRef = useRef(null);
    const { success, error } = useToast();

    const handleUploadPdf = async (file) => {
        if (!file || !temaId) return;

        try {
            setUploadingPdf(true);
            const result = await ope.adminUploadPdf(temaId, file);
            
            success('PDF subido y procesado correctamente');
            if (fileInputRef.current) fileInputRef.current.value = '';
            
            if (onUploadSuccess) {
                onUploadSuccess(result);
            }
        } catch (err) {
            console.error('Error uploading PDF:', err);
            error(err.message || 'Error al subir PDF');
        } finally {
            setUploadingPdf(false);
        }
    };

    return (
        <div className="p-4 bg-white/5 rounded-xl border border-white/10 space-y-3 ml-4">
            <div className="border-2 border-dashed border-white/10 rounded-xl p-8 text-center hover:bg-white/5 transition-colors cursor-pointer relative">
                <input
                    ref={fileInputRef}
                    type="file"
                    accept=".pdf"
                    onChange={(e) => handleUploadPdf(e.target.files[0])}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                    disabled={uploadingPdf}
                />
                {uploadingPdf ? (
                    <div className="flex flex-col items-center justify-center gap-3">
                        <div className="w-8 h-8 border-4 border-indigo-500/30 border-t-indigo-500 rounded-full animate-spin"></div>
                        <p className="text-indigo-300 font-medium animate-pulse">Procesando y extrayendo texto...</p>
                    </div>
                ) : (
                    <>
                        <Upload className="w-8 h-8 text-indigo-400 mx-auto mb-3" />
                        <p className="text-gray-300 font-medium">Seleccionar PDF</p>
                        <p className="text-sm text-gray-500 mt-1">Arrastra o haz clic para subir</p>
                    </>
                )}
            </div>
            {pdfFilename && (
                <div className="text-sm text-gray-400">
                    <p>📄 <strong>{pdfFilename}</strong></p>
                    <p>📏 {textoChars?.toLocaleString()} caracteres extraídos</p>
                    <p>💡 Preguntas sugeridas: ~{Math.round((textoChars || 0) / 500)}</p>
                </div>
            )}
        </div>
    );
};

export default OpeAdminPdfUploader;
